import api from '../utils/api';

export const freshnessService = {
  getStatus: async (listingId) => {
    const res = await api.get(`/freshness/status/${listingId}`);
    return res.data?.data;
  },

  getVehicleAlerts: async () => {
    const res = await api.get('/freshness/vehicle-alerts');
    return res.data?.data || [];
  },

  markSold: async (listingId) => {
    const res = await api.post(`/freshness/listings/${listingId}/mark-sold`);
    return res.data;
  },

  confirmAvailable: async (listingId) => {
    const res = await api.post(`/freshness/listings/${listingId}/confirm-available`);
    return res.data;
  },

  recordView: async (listingId) => {
    const res = await api.post(`/freshness/listings/${listingId}/view`);
    return res.data;
  },
};

export default freshnessService;
